import ArticleLayout from '@/components/feature/ArticleLayout';

export default function JerseyArticle() {
  return (
    <>
      <title>Superbuy Spreadsheet Jersey &amp; Sportswear: Athletic Apparel and Team Style Discovery Guide</title>
      <meta name="description" content="Complete Superbuy Spreadsheet jersey and sportswear guide — discover basketball jerseys, soccer kits, football shirts, performance athletic wear, and team-inspired style. Sizing tips, fabric tech, and curated 2026 finds." />
      <meta name="keywords" content="superbuy spreadsheet jersey, superbuy sheet sportswear, superbuy basketball jersey, superbuy soccer jersey spreadsheet, superbuy athletic wear, superbuy spreadsheet football jersey, superbuy performance wear" />
      <link rel="canonical" href={`${import.meta.env.VITE_SITE_URL || 'https://superbuyspread.makeup'}/superbuy-spreadsheet-jersey`} />
      <ArticleLayout slug="superbuy-spreadsheet-jersey" />
    </>
  );
}